import React from 'react';
import {View} from 'MWC';
import PropTypes from 'prop-types';
import tpl from '../templates/owners.jsx';
import widgetsHelper from 'utils/getWidget.helper';
import buildUrl from 'utils/buildGetURLWithParams';
import {apiback} from '../../../config';
import {environment} from 'environment/environment';
import {canUseDOM} from '../../../helpers/canUseDOM';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: tpl,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            where_by: ['path'],
            search_by: ['/about/top'],
            loader: true,
            widgets: [],
            where_by_2: ['path'],
            search_by_2: ['/about/general'],
            widgets_2: [],
            where_by_3: ['path'],
            search_by_3: ['/about/owners'],
            widgets_3: [],
            widgets_4: [],
            widgets_4_loading: true,
            tablesSelectedData: {},
            where_by_meetings: ['path'],
            search_by_meetings: ['/about/top'],
            widgetName: 'meetings',
            data: [],
            meetingsLoading: true,
            isMobileTable: canUseDOM ? window.innerWidth <= 960 : false,
            tooltipNotice: {visible: false, x: 0, y: 0, html: ''}
        };

        this.widgetsHelper = widgetsHelper;
        this.select = this.select.bind(this);
        this.esgRef = React.createRef();
        this.esgScrollPending = false;
        this.esgScrollTimeout = null;
        return this;
    }

    componentWillMount() {
        if (!canUseDOM) {
            const {ssrData} = this.props;
            if (ssrData) {
                this.setState({
                    widgets: ssrData.widgets || [],
                    widgets_2: ssrData.widgets_2 || [],
                    widgets_3: ssrData.widgets_3 || [],
                    widgets_4: ssrData.widgets_4 || [],
                    loader: false,
                    widgets_4_loading: false
                });
            }
            return;
        }
        this.widgetsHelper.getWidgets.call(this);
        this.widgetsHelper.getWidgets_2.call(this);
        this.widgetsHelper.getWidgets_3.call(this);
        this.widgetsHelper.getWidgetsByPath.call(this, {
            path: '/about/owners/sustainable_development',
            widgetKey: 'widgets_4'
        });
        this.checkWidget();
    }

    updateWidth = () => {
        this.setState({isMobileTable: window.innerWidth <= 960});
    };

    componentDidMount() {
        if (!canUseDOM) return;
        window.addEventListener('resize', this.updateWidth);
        document.addEventListener('scroll', this.hideTooltip, true);
        if (this.props.location && new URLSearchParams(this.props.location.search).has('esg')) {
            this.esgScrollPending = true;
        }
        this.unlisten = this.props.history.listen(location => {
            if (new URLSearchParams(location.search).has('esg')) {
                this.esgScrollPending = true;
            }
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (!canUseDOM) return;

        const isEsg = this.props.location && new URLSearchParams(this.props.location.search).has('esg');
        const allLoaded =
            !this.state.loader && !this.state.widgets_4_loading && !this.state.meetingsLoading;
        const wasLoading =
            prevState.loader || prevState.widgets_4_loading || prevState.meetingsLoading;
        const prevIsEsg = prevProps.location && new URLSearchParams(prevProps.location.search).has('esg');
        const locationChangedToEsg = isEsg && !prevIsEsg;

        if (locationChangedToEsg || (isEsg && wasLoading)) {
            this.esgScrollPending = true;
        }

        if (this.esgScrollPending && allLoaded && this.esgRef.current) {
            clearTimeout(this.esgScrollTimeout);
            this.esgScrollTimeout = setTimeout(() => {
                if (
                    this.esgScrollPending &&
                    this.esgRef.current &&
                    this.esgRef.current.offsetParent !== null
                ) {
                    this.esgRef.current.scrollIntoView({behavior: 'smooth'});
                    this.esgScrollPending = false;
                }
            }, 50);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWidth);
        document.removeEventListener('scroll', this.hideTooltip, true);
        if (this.unlisten) this.unlisten();
        clearTimeout(this.esgScrollTimeout);
    }

    checkWidget = () => {
        const {where_by, search_by} = this.state,
            pageParams = {where_by, search_by};
        const url = buildUrl(apiback('API_PAGES'), pageParams);

        fetch(url)
            .then(res => res.json())
            .then(({data}) => {
                if (data.length > 0) {
                    const widgets = data[0].pageWidgets.find(
                        el => el.code === this.state.widgetName
                    );

                    const widgetsData = widgets
                        ? widgets.data.map(widget => {
                              return {
                                  ...widget,
                                  columns: widget.columns.sort((a, b) => a.id - b.id)
                              };
                          })
                        : [];
                    const tablesSelectedData = widgetsData
                        .map(el => {
                            return {
                                id: el.id,
                                selected: {id: el.columns[0].id, name: el.columns[0].name_ua}
                            };
                        })
                        .reduce((acc, table) => {
                            const {id, selected} = table;
                            return {...acc, [id]: selected};
                        }, {});
                    this.setState({
                        data: widgetsData,
                        tablesSelectedData: tablesSelectedData
                    });
                }
                this.setState({meetingsLoading: false});
            })
            .catch(() => {
                this.setState({meetingsLoading: false});
            });
    };

    changeFilesUrl(url) {
        const baseUrl = apiback('API_PAGES');
        const backendUrl = environment.url + '/backend';
        if (url.includes('/pages')) {
            return backendUrl + url;
        } else if (url.startsWith('http')) {
            return url;
        } else {
            return baseUrl + url.slice(7);
        }
    }

    switchTab(tab) {
        return this.setState({tab});
    }

    showTooltip = (e, html) => {
        const rect = e.currentTarget.getBoundingClientRect();
        this.setState({
            tooltipNotice: {visible: true, x: rect.left + rect.width / 2, y: rect.top, html}
        });
    };

    hideTooltip = () => {
        this.setState(prev => ({
            tooltipNotice: {...prev.tooltipNotice, visible: false}
        }));
    };

    select(e, options, tableId) {
        const id = e.target.value,
            selected = options.find(term => term.id === id);
        this.setState({
            tablesSelectedData: {...this.state.tablesSelectedData, [tableId]: selected}
        });
    }

    static displayName = 'About.Views.Owners';

    static contextTypes = {
        app: PropTypes.object,
        history: PropTypes.object
    };
}
